import { Container } from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import { useForm } from "react-hook-form";
import swal from "sweetalert";

const PhysicsOffAdmin = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    fetch("https://thawing-springs-61404.herokuapp.com/PhysicsOffAdmin", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => res.json());
    // .then((result) => console.log(result));
    //   console.log(data); reset({ something: '' });
    reset();
    swal("Done!", "You Added New Class in WebApp !", "success");
  };
  return (
    <Container className="py-5 my-5 mx-auto">
      <h2>STPO Webapp Admin Panel</h2>
      <Box className="py-5 my-5 ">
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* register your input into the hook by invoking the "register" function */}
          <input placeholder="Chapter" {...register("Chapter")} />
          <br />
          <input placeholder="Subject" {...register("Subject")} />
          <br />
          <input placeholder="ClassLink" {...register("ClassLink")} />
          <br />
          <input placeholder="Pdf" {...register("Pdf")} />
          <br />

          {errors.exampleRequired && <span>This field is required</span>}

          <input
            className="px-2 py-1 bg-success my-2 text-white"
            type="submit"
          />
        </form>
      </Box>
    </Container>
  );
};

export default PhysicsOffAdmin;
